module.exports = __webpack_public_path__ + "static/media/icon_73.792eb5ad.svg";